import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: Dates
 *
 * Displays dates affiliated with a risk record.
 *
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function Dates({ riskRecord = {} }) {
  const data = {
    createdDate: riskRecord?.createdDate,
    lastModifiedDate: riskRecord?.lastModifiedDate,
    replayStreamReceived: riskRecord?.replayStreamTimeReceived,
    streamReceived: riskRecord?.streamTimeReceived,
  };

  return (
    <ErrorHandler location="src/widgets/RiskRecords/Dates/Dates.jsx">
      {isEmpty(data) ? (
        <Alert title="There are no dates for this risk record." variant="info" />
      ) : (
        <Table data={data} />
      )}
    </ErrorHandler>
  );
}
